package io.horion.cv.models

import androidx.compose.runtime.Composable
import io.horion.cv.components.forms.PersonalDetailsForm
import io.horion.cv.components.forms.ProfileForm

data class AccordionSection(
    val id: String,
    val title: String,
    val content: @Composable () -> Unit,
)

val accordionSections = listOf(
    AccordionSection(
        id = "personal_info",
        title = "Informations personnelles",
        content = { PersonalDetailsForm() }
    ),
    AccordionSection(
        id = "profil",
        title = "Profile",
        content = { ProfileForm() }
    ),
    AccordionSection(
        id = "education",
        title = "Formation",
        content = { }
    ),
    AccordionSection(
        id = "experience",
        title = "Expérience professionnelle",
        content = { }
    ),
    AccordionSection(
        id = "skills",
        title = "Compétences",
        content = { }
    ),
    AccordionSection(
        id = "interest",
        title = "Centres d'intérêts",
        content = { }
    ),
    AccordionSection(
        id = "languages",
        title = "Langues",
        content = { }
    ),
    AccordionSection(
        id = "activite",
        title = "Activités extra-scolaires",
        content = { }
    ),
    AccordionSection(
        id = "qualite",
        title = "Qualités",
        content = { }
    )
)